// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1VazN","file":"styles_file__3R2q9"};